<template>
    <div class="animated fadeIn">
        <b-card class="card-accent-info">

            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="facebook" class="mr-1 btn-brand" @click="openMdfeModal()"><i class="fa fa-toggle-on"></i><span>Consulta Placa</span></b-button>
              </b-form-group>
            </b-col>

        </b-card>

        <b-modal
              v-model="mdfeModal"
              id="mdfe-modal"
              centered
              hide-footer
              title="Consulta Placa"
              size="lg">

            <b-card> 

                <b-form @submit.stop.prevent="onSubmit">
            
                    <div class="animated fadeIn">
                
                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Praça"
                                label-for="plaza"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-input class="text-uppercase" v-model="plaza" id="plaza" type="text" placeholder=""></b-form-input>
                            </b-form-group> 
                            </b-form>
                            </b-col>
                        </b-row>

                        
                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Pista"
                                label-for="lane"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-input v-model="lane" id="lane" type="number" placeholder=""></b-form-input>
                            </b-form-group> 
                            </b-form>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Placa"
                                label-for="plate"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-input class="text-uppercase" v-model="plate" id="plate" type="text" placeholder=""></b-form-input>
                                
                            </b-form-group> 
                            </b-form>
                            </b-col>
                        </b-row>
                            
                        <b-input-group class="mb-4">
                            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                        </b-input-group>
                        
                    </div>
                </b-form>

                <div slot="footer" class="text-right">
                    <b-button variant="github" class="mr-1 btn-brand" @click="getMdfeByPlate()"><i class="fa fa-check"></i><span>Consultar Placa</span></b-button>
                </div>
                      
            </b-card>

         </b-modal>

    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'dev',
    data: function() {
        return {
            appCode: 'WS',
            appName: 'sgap-protocol',
            plaza: '191',
            lane: 4,
            plate: '',
            errorMessage: '',
            mdfeModal: false,
           
        }
    },
    methods: {
        async postMdfeByPlate() {
            
            var s = this;
            var currentUser = this.$store.state.currentUser;
          
            //console.log(this.$store.state.ws_url + "/mdfe?appName=" + s.appName + "&appCode=" + s.appCode + "&plaza=" + s.plaza + "&lane=" + s.lane + "&plate=" + s.plate);


            await axios.get(
                this.$store.state.ws_url + "/mdfe?appName=" + s.appName + "&appCode=" + s.appCode + "&plaza=" + s.plaza + "&lane=" + s.lane + "&plate=" + s.plate
            ).then(function(resp) {
                console.log(resp)   
                s.errorMessage = 'Consulta realizada com sucesso'
            })            
            .catch(function(error) {
                console.log(error)
                s.errorMessage = 'Erro ao realizar consulta por placa'
            });
            
        },
        getMdfeByPlate() {
            if(this.plate && this.plate.length >= 7) {
                this.postMdfeByPlate()
                this.errorMessage = ''
            }
            else {
                this.errorMessage = 'Favor preencher os campos obrigatórios.'
                toast ({
                    type: VueNotifications.types.error,
                    title: 'MDFe',
                    message: 'Favor preencher os campos obrigatório.',
                    timeout: 3000
                })
            }
        },
        closeMdfeModal() {
            this.mdfeModal = false
        },
        openMdfeModal() {
            this.mdfeModal = true
        }
    }
}
</script>
  
<style>
/* IE fix */
#card-chart-01, #card-chart-02 {
    width: 100% !important;
}
</style>
  